export default "__VITE_ASSET__Dt7aiFT___"